module.exports = __webpack_public_path__ + "static/media/sparky.7ea3dcbb.gif";